import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { PainSection } from './components/PainSection';
import { IdentityWound } from './components/IdentityWound';
import { MechanismSection } from './components/MechanismSection';
import { AuthorSection } from './components/AuthorSection';
import { ChaptersSection } from './components/ChaptersSection';
import { BenefitsTranslation } from './components/BenefitsTranslation';
import { ForYouNotForYou } from './components/ForYouNotForYou';
import { Testimonial } from './components/Testimonial';
import { SoulQuotes } from './components/SoulQuotes';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[var(--midnight)]" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <PainSection data-id="element-3" />
      <IdentityWound data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <AuthorSection data-id="element-6" />
      <ChaptersSection data-id="element-7" />
      <BenefitsTranslation data-id="element-8" />
      <ForYouNotForYou data-id="element-9" />
      <Testimonial data-id="element-10" />
      <SoulQuotes data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}